export default __webpack_public_path__ + "static/tile-anatomy-dark-bfc976edff2a3ae11ccffd3f2b8eb5e6.png";